import { render, staticRenderFns } from "./MedicalReportCombined.vue?vue&type=template&id=422c56c4&scoped=true&"
import script from "./MedicalReportCombined.vue?vue&type=script&lang=js&"
export * from "./MedicalReportCombined.vue?vue&type=script&lang=js&"
import style0 from "./MedicalReportCombined.vue?vue&type=style&index=0&id=422c56c4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422c56c4",
  null
  
)

export default component.exports